import _ from 'lodash';
import { refHostingTypeService } from '@/services';
import { GUID_EMPTY } from '@/helpers';
import {
    GET_BY_ACCOUNT_ID,
    GET_BY_ID,
    ADD,
    UPDATE,
    DELETE
} from "./actions.type";
import {
    GET_ALL_REQUEST,
    GET_ALL_SUCCESS,
    GET_ALL_FAILURE,
    GET_BY_ID_REQUEST,
    GET_BY_ID_SUCCESS,
    GET_BY_ID_FAILURE,
    CLEAR_ITEMS,
    CLEAR_CURRENT_ITEM,
    UPDATE_CURRENT_ITEM
} from "./mutations.type";

function getBlankRefHostingType() {
    return {
        refHostingTypeId: GUID_EMPTY,
        accountId: GUID_EMPTY,
        shortName: "",
        name: "",
        notes: "",
        displayOrder: null,
        applicationCount: 0
    };
}

export const refhostingtypes = {
    namespaced: true,
    state: {
        status: {
            loading: false,
            loaded: false,
            failed: false,
            error: null
        },
        items: [],
        currentRefHostingType: getBlankRefHostingType()
    },
    getters: {

    },
    actions: {
        [GET_BY_ACCOUNT_ID]({ commit }, accountId) {
            return new Promise((resolve, reject) => {
                commit(GET_ALL_REQUEST);

                refHostingTypeService.getByAccount(accountId)
                    .then(
                        refHostingTypes => {
                            commit(GET_ALL_SUCCESS, refHostingTypes);
                            resolve(refHostingTypes);
                        },
                        error => {
                            commit(GET_ALL_FAILURE, error);
                            reject(error);
                        }
                    );
            });
        },
        [GET_BY_ID]({ commit }, refHostingTypeId) {
            return new Promise((resolve, reject) => {
                commit(GET_BY_ID_REQUEST);

                return refHostingTypeService.getById(refHostingTypeId)
                    .then(
                        refHostingType => {
                            commit(GET_BY_ID_SUCCESS, refHostingType);
                            resolve(refHostingType);
                        },
                        error => {
                            commit(GET_BY_ID_FAILURE, error);
                            reject(error);
                        }
                    );
            });
        },
        [ADD]({ dispatch, commit }, refHostingType) {
            return refHostingTypeService.add(refHostingType);
        },
        [UPDATE]({ dispatch, commit }, refHostingType) {
            return refHostingTypeService.update(refHostingType);
        },
        [DELETE]({ dispatch, commit }, refHostingType) {
            return refHostingTypeService.deleteEntity(refHostingType);
        },
    },
    mutations: {
        [GET_ALL_REQUEST](state) {
            state.status = { loading: true };
        },
        [GET_ALL_SUCCESS](state, refHostingTypes) {
            state.status = { loaded: true };
            state.items = refHostingTypes;
        },
        [GET_ALL_FAILURE](state, error) {
            state.status = { failed: true, error };
            state.items = [];
        },
        [GET_BY_ID_REQUEST](state) {
            state.status = { loading: true };
        },
        [GET_BY_ID_SUCCESS](state, refHostingType) {
            state.status = { loaded: true };
            state.currentRefHostingType = refHostingType;
        },
        [GET_BY_ID_FAILURE](state, error) {
            state.status = { failed: true, error };
            state.currentRefHostingType = getBlankRefHostingType();
        },
        [CLEAR_ITEMS](state) {
            state.items = [];
        },
        [CLEAR_CURRENT_ITEM](state) {
            state.currentRefHostingType = getBlankRefHostingType();
        },
        [UPDATE_CURRENT_ITEM](state, { field, value }) {
            // see https://ypereirareis.github.io/blog/2017/04/25/vuejs-two-way-data-binding-state-management-vuex-strict-mode/
            Object.assign(state.currentRefHostingType, {
                [field]: value
            });
        },
    }
}
